export default __webpack_public_path__ + "static/media/yaloo.b186ecb7.png";